import type { SxProps, Theme } from '@mui/material';
import { Color } from 'shared/utils/colors';
import { ComplianceAnswerOption } from './complianceAnswerOption';

export const complianceButtonSx: SxProps<Theme> = {
  padding: '15px 20px',
  minHeight: 56,
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  color: Color.black,
  borderColor: Color.neutralBorderGray,
  flex: 1,
  minWidth: 0,
};

export const complianceGreenButtonSx: SxProps<Theme> = {
  '&:hover': {
    background: Color.accentGreen600Bg10,
  },
  '&.Mui-selected': {
    color: Color.accentGreen600,
    background: Color.accentGreen600Bg15,
    border: `1px solid ${Color.accentGreen600}`,
  },
  '&.Mui-selected:hover': {
    color: Color.accentGreen600,
    background: Color.accentGreen600Bg25,
  },
};

export const complianceRedButtonSx: SxProps<Theme> = {
  '&:hover': {
    background: Color.redBg13,
  },
  '&.Mui-selected': {
    color: Color.red,
    background: Color.redBg18,
    border: `1px solid ${Color.red}`,
  },
  '&.Mui-selected:hover': {
    color: Color.red,
    background: Color.redBg28,
  },
};

export const complianceNeutralButtonSx: SxProps<Theme> = {
  '&:hover': {
    background: Color.hoverBackground,
  },
  '&.Mui-selected': {
    color: Color.slateGray,
    background: Color.solidGray,
    border: `1px solid ${Color.neutralBorderGray}`,
  },
  '&.Mui-selected:hover': {
    color: Color.slateGray,
    background: Color.disabledGray,
  },
};

export const complianceToggleButtonTextSx: SxProps<Theme> = {
  textTransform: 'uppercase',
  fontWeight: 'bold',
  overflowWrap: 'anywhere',
};

export const complianceToggleGroupSx: SxProps<Theme> = {
  display: 'flex',
  width: '100%',
  // Full width so Pass / Fail sit in one row with the N/A toggle on protocol items.
  maxWidth: '100%',
  minWidth: 0,
  flexWrap: 'wrap',
  '& .MuiToggleButton-root': {
    lineHeight: 'unset',
    flex: '1 1 auto',
    minWidth: 0,
  },
};

export function getComplianceButtonStyleForOption(
  option: ComplianceAnswerOption
): SxProps<Theme> {
  switch (option) {
    case ComplianceAnswerOption.passed:
      return complianceGreenButtonSx;
    case ComplianceAnswerOption.notPassed:
      return complianceRedButtonSx;
    case ComplianceAnswerOption.notApplicable:
      return complianceNeutralButtonSx;
    default:
      return {};
  }
}
